import LegacyPicture from '@uikit/components/LegacyPicture/LegacyPicture';
import styles from './MagazineHeroCarousel.module.scss';
import type { MagazineHeroCarouselItemProps } from './interfaces';

const MagazineHeroCarouselItem = ({ image }: MagazineHeroCarouselItemProps) => {
  return (
    <div className={styles.thumbnail}>
      <LegacyPicture asset={image} />
    </div>
  );
};

export default MagazineHeroCarouselItem;
